// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_SELLERS_ON_SERVER = "Predajcovia v baz\u00e1ri";
